import React from "react";
import styles from "../styles/styles.module.css";
import { ReactComponent as GiveMoneyIcon } from "../../../assets/icons/give-money-icon.svg";
import { Button } from "antd";

const LiquidateCash = () => {
  return (
    <div className={styles.liquidateCash}>
      <header className={styles.liquidateCashHeader}>
        <h2>RECEPCIÓN DE EFECTIVO</h2>
      </header>
      <section className={styles.liquidateCashContent}>
        <GiveMoneyIcon />
        <div className={styles.liquidateCashInfo}>
          <p>
            Ticket: <span>L-238976</span>
          </p>
          <p>
            Driver: <span>Francisco Enrique Jimenez</span>
          </p>
          <p>
            Monto: <span>$16.55</span>
          </p>
        </div>
      </section>

      <footer className={styles.liquidateCashFooter}>
        <Button style={{height: 40}}  type="primary" className={styles.liquidateCashButton}>
          CONFIRMAR DE RECIBIDO
        </Button>
      </footer>
    </div>
  );
};

export default LiquidateCash;
